var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { attrs: { method: "get", action: "/groepen" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row row--fields" }, [
      _c("div", { staticClass: "column small-24" }, [
        _c(
          "div",
          { staticClass: "formfield input input--zip" },
          [_c("LocationSearch", { attrs: { name: "locatie" } })],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row row--fields" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "formfield" }, [
          _c("div", { staticClass: "customselect" }, [
            _c(
              "select",
              { attrs: { name: "filter" } },
              _vm._l(_vm.selectItems, function (item) {
                return _c(
                  "option",
                  { attrs: { value: "1" }, domProps: { value: item.value } },
                  [_vm._v(_vm._s(item.key))]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row row--fields" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "headersearch__title h5" }, [
          _vm._v("Vind een groep of initiatief"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "btn__headersearch" }, [
          _c("button", { staticClass: "btn" }, [
            _vm._v("Zoeken in aanbod "),
            _c("i", { staticClass: "icon-arrow-right" }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }